<navbar class="docs-navbar-header_fixed"></navbar>

<main role="main" class="site__main main">
    <app-sidenav></app-sidenav>
    <article class="main__content content">
        <div class="content__wrapper">
            <router-outlet></router-outlet>
        </div>
    </article>
</main>

<footer></footer>
